import { render, staticRenderFns } from "./resume-extra-item.vue?vue&type=template&id=43d272a4&scoped=true&"
import script from "./resume-extra-item.vue?vue&type=script&lang=js&"
export * from "./resume-extra-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d272a4",
  null
  
)

export default component.exports